export enum MapSide {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
